import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoBannerIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 41 41.5",
	style: { enableBackground: "new 0 0 41 41.5" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:#F5F4FF;}\n	.st1{fill:#4c43a3;}\n"
		}),
		/* @__PURE__ */ _jsx("title", { children: "Asset 1" }),
		/* @__PURE__ */ _jsx("g", {
			id: "Layer_2",
			children: /* @__PURE__ */ _jsxs("g", {
				id: "Layer_1-2",
				children: [
					/* @__PURE__ */ _jsx("path", {
						className: "st0",
						d: "M20.5,0C31.9,0.1,41.1,9.4,41,20.8c0,0,0,0,0,0c0.1,11.4-9.1,20.7-20.5,20.7C9.1,41.4-0.1,32.1,0,20.8 C-0.1,9.4,9.1,0.1,20.5,0C20.5,0,20.5,0,20.5,0z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "st1",
						d: "M20.5,6.3c8,0,14.5,6.5,14.5,14.5s-6.5,14.5-14.5,14.5S6,28.8,6,20.8C6,12.8,12.5,6.3,20.5,6.3 M20.5,3.3 C10.8,3.3,3,11.1,3,20.8s7.8,17.5,17.5,17.5S38,30.4,38,20.8S30.2,3.3,20.5,3.3C20.5,3.3,20.5,3.3,20.5,3.3z"
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "st1",
						d: "M22.4,10.8c1.1,0,2.1,0.9,2.1,2.1c0,0.6-0.2,1.1-0.6,1.5C23,15,21.7,14.8,21,13.9c-0.6-0.8-0.6-1.8,0-2.6 C21.4,11,21.9,10.8,22.4,10.8z M23.3,17.3l-2.9,10c-0.1,0.4-0.2,0.7-0.2,1.1c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.2,0.1,0.3,0.1 c0.2,0,0.4-0.1,0.5-0.2c0.6-0.6,1.1-1.2,1.5-1.9L23,27c-1.4,2.5-2.9,3.7-4.5,3.7c-0.5,0-1.1-0.1-1.5-0.5c-0.4-0.3-0.6-0.8-0.5-1.3 c0-0.5,0.1-0.9,0.2-1.3l2-6.8c0.2-0.5,0.3-1,0.3-1.5c0-0.2-0.1-0.4-0.3-0.5c-0.2-0.2-0.5-0.3-0.7-0.2h-0.5l0.2-0.6l4.8-0.8 L23.3,17.3z"
					})
				]
			})
		})
	]
});
export default SvgInfoBannerIcon;
